export namespace MapMarkerConstants {
  export const DRIVER_MARKER_COLOR_INACTIVE: string = '#D5D5D5';
  export const DRIVER_MARKER_COLOR_PERIOD1: string = '#BA55D3';
  export const DRIVER_MARKER_COLOR_EN_ROUTE: string = '#fdd032';
  export const DRIVER_MARKER_COLOR_PICK_UP_ARRIVED: string = '#38c3cd';
  export const DRIVER_MARKER_COLOR_IN_PROGRESS: string = '#89c337';
  export const DRIVER_MARKER_COLOR_DROP_OFF_ARRIVED: string = '#ac85e5';
}
